import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import { navigate } from "vike/client/router"
import Typography from "aldoo-ra/Typography"
import ReadTimeBadge from "./read-time-badge"

const LatestArticleBanner = () => {
  return (
    <CMSRender
      contentType="BlogPost"
      sort={{ "content.publish_date": -1 }}
      page={1}
      itemsPerPage={1}
      match={{
        "content.status": "published",
      }}
      renderItem={(post) => {
        const href = `/blog/${post.slug}`
        return (
          <a href={href} className="flex flex-col">
            <div className="relative w-full h-full rounded-[28px] md:rounded-[50px] lg:aspect-[626/340] overflow-hidden cursor-pointer group">
              {/* Background Image */}
              <img
                src={post.thumbnail}
                alt={post.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />

              {/* Read Time Badge */}
              <ReadTimeBadge
                data={post}
                top="4"
                topMd="6"
                right="4"
                rightMd="8"
              />
            </div>

            {/* Article Title */}
            <div className="w-full py-4 md:py-10">
              <Typography variant="h3" className="text-textmd:line-clamp-3">
                {post.title}
              </Typography>
            </div>
          </a>
        )
      }}
    />
  )
}

export default LatestArticleBanner
